<header>

    <nav class="navbar navbar-expand-lg custon-nav">
        <div class="container-fluid">
            <a class="burger-btn d-block cursor-pointer">
                <span class="material-symbols-outlined">menu</span>
            </a>
            <div class="navbar-end">
                <ul class="navbar-nav">
                    <div #dropdown class="dropdown">
                        <a (click)="toggleDropdown()">
                            <div class="user-menu d-flex">
                                <div class="user-name text-end me-3">
                                    <h6 class="mb-0 text-gray-600">{{user.fullname}}</h6>
                                    <p class="mb-0 text-sm text-gray-600">{{profile.name}}</p>
                                </div>
                                @if(user?.gender?.key == 2) {
                                    <div class="user-img d-flex align-items-center">
                                        <div class="avatar avatar-md">
                                            <img src="images/avatar_woman.png">
                                        </div>
                                    </div>
                                } @else if(user?.gender?.key == 1) {                              
                                    <div class="user-img d-flex align-items-center">
                                        <div class="avatar avatar-md">
                                            <img src="images/avatar_men.png">
                                        </div>
                                    </div>
                                } @else {
                                    <div class="user-img d-flex align-items-center">
                                        <div class="avatar avatar-md">
                                            <img src="images/avatar_default.png">
                                        </div>
                                    </div>
                                }
                            </div>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end" [class]="{ 'show': dropdownOpen }" aria-labelledby="dropdownMenuButton" style="min-width: 11rem;">
                            <li>
                                <h6 class="dropdown-header">Hola ¡{{user.name}}!</h6>
                            </li>
                            <!-- <li>
                                <a class='dropdown-item' >
                                    <i class="material-symbols-outlined">
                                        account_circle
                                    </i>
                                    <div class="dropdown-item-title">Mi cuenta</div>
                                </a>
                            </li>
                            <li>
                                <hr class="dropdown-divider">
                            </li>
                            <li>
                                <h6 class="dropdown-header">Administración</h6>
                            </li>
                            <li>
                                <a class="dropdown-item">
                                    <i class="material-symbols-outlined">
                                        group
                                        </i>
                                    <div class="dropdown-item-title">Usuarios</div>
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item">
                                    <i class="material-symbols-outlined">
                                        badge
                                        </i>
                                    <div class="dropdown-item-title">Perfiles</div>
                                </a>
                            </li>
                            <li>
                                <hr class="dropdown-divider">
                            </li> -->
                            <li>
                                <a class="dropdown-item" (click)="logout()">
                                    <i class="material-symbols-outlined"> logout </i>
                                    <div class="dropdown-item-title">Cerrar sesion</div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </ul>
            </div>
        </div>
    </nav>

</header>